﻿import { FormViewModel } from '../main/LoginRegistration.js';

/** ViewModel for the Warranty form. */
export class WarrantyFormViewModel extends FormViewModel {
  constructor(config) {
    super(config);
    const byId = id => document.getElementById(id);
    const validator = this.formValidator.add(byId(config.UI.damageType));
    /* If we do server-side validation for this field (in the WarrantyAndReturnsController's SubmitForm
     * method), then we should add the following to hide the server generated error message as soon
     * as we start typing: */
    //validator.onCustomValidate = input => !input.classList.contains('is-invalid');
    //validator.onGetMessage = () => null;

    this.formValidator.add(byId(config.UI.purchaseLocation));
    this.formValidator.add(byId(config.UI.retailerName));
    this.formValidator.add(byId(config.UI.personName));
    this.formValidator.add(byId(config.UI.email));
    this.formValidator.add(byId(config.UI.orderNo));
    this.formValidator.add(byId(config.UI.damageDescription));
  }
}
